<template>
	<div class="lbt">
		<div class="bgtp" v-show="num==0">
			<img src="@/static/home/banner/banner1.png" alt="" />
		</div>
		<div class="bgtp" v-show="num==1">
			<img src="@/static/home/banner/banner2.png" alt="" />
		</div>
		<div class="bgtp" v-show="num==2">
			<img src="@/static/home/banner/banner3.png" alt="" />
		</div>
		<div class="bgtp" v-show="num==3">
			<img src="@/static/home/banner/banner4.png" alt="" />
		</div>
		<div class="lbtext1 lbbox" v-show="num==0">
			<img class="name1" src="@/static/home/banner/banner1Text1.png" alt="" />
			<img class="name2" src="@/static/home/banner/banner1Text2.png" alt="" />
		</div>
		<div class="lbtext2 lbbox" v-show="num==1">
			<img class="name1" src="@/static/home/banner/banner2Text1.png" alt="" />
			<img class="name2" src="@/static/home/banner/banner2Text2.png" alt="" />
		</div>
		<div class="lbtext3 lbbox" v-show="num==2">
			<img class="name1" src="@/static/home/banner/banner3Text1.png" alt="" />
			<img class="name2" src="@/static/home/banner/banner3Text2.png" alt="" />
		</div>
		<div class="lbtext4 lbbox" v-show="num==3">
			<img class="name1" src="@/static/home/banner/banner4Text1.png" alt="" />
			<img class="name2" src="@/static/home/banner/banner4Text2.png" alt="" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				num:0,		//轮播图现在到第几个
				tirm:null,	//定时器
				list:[],
			}
		},
		created(){
			this.Rotation();
		},
		methods:{
			Rotation(){	//轮播图开始定时
				var that = this
				this.tirm = setInterval(function(){
					if(that.num<3){
						that.num++
					}else{
						that.num = 0
					}
				},6000)
			},
		},
		beforeDestroy(){	//退出页面时间
			// 清除定时器
			clearInterval(this.tirm)
			this.tirm = null;
		}
	}
</script>

<style scoped lang="less">
	.lbt{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.bgtp{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		transition: 1s all;
		img{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: 1s all;
			background-repeat: no-repeat;
			animation: bgimg 12s;
			animation-fill-mode: forwards;
		}
	}
		@keyframes bgimg{
			0%{
				transform: scale(1.2);
				opacity: 1;
			}
			20%{
				transform: scale(1);
				opacity: 1;
				z-index: 2;
			}
			75%{
				transform: scale(1);
				opacity: 1;
				z-index: 3;
			}
			100%{
				transform: scale(1.2);
				opacity: 0;
				z-index: 3;
			}
		}
	.lbbox{
		display: flex;
		align-items: center;
	}
	@keyframes lb1img{
		0%{
			transform:translateX(-50%);
			opacity: 0;
		}
		100%{
			opacity: 1;
		}
	}
	@keyframes text1{
		0%{
			transform: scale(1.2);
			opacity: 0;
		}
		100%{
			transform: scale(1);
			opacity: 1;
		}
	}
	.lbtext1{
		position: absolute;
		top: 200px;
		right: 5%;
		z-index: 10;
	}
	.lbtext1 .name1{
		width: 195px;
		height: 390px;
		opacity: 0;
		animation: text1 2s;
		animation-fill-mode: forwards;
	}
	.lbtext1 .name2{
		margin:30px 0 0 0;
		width: 92px;
		height: 298px;
		text-align: center;
		color: #fff;
		opacity: 0;
		animation: lb1img 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	.lbtext2{
		position: absolute;
		top: 200px;
		right: 5%;
		z-index: 10;
	}
	.lbtext2 .name1{
		width: 213px;
		height: 318px;
		opacity: 0;
		animation: text1 2s;
		animation-fill-mode: forwards;
	}
	.lbtext2 .name2{
		position: relative;
		top:120px;
		right: 50px;
		width: 92px;
		height: 298px;
		text-align: center;
		color: #fff;
		opacity: 0;
		animation: lb1img 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	.lbtext3{
		position: absolute;
		top: 200px;
		right: 5%;
		z-index: 10;
	}
	.lbtext3 .name1{
		width: 201px;
		height: 282;
		opacity: 0;
		animation: text1 2s;
		animation-fill-mode: forwards;
	}
	.lbtext3 .name2{
		margin:70px 0 0 0;
		width: 92px;
		height: 298px;
		text-align: center;
		color: #fff;
		opacity: 0;
		animation: lb1img 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	.lbtext4{
		position: absolute;
		top: 200px;
		right: 5%;
		z-index: 10;
	}
	.lbtext4 .name1{
		width: 182px;
		height: 302px;
		opacity: 0;
		animation: text1 2s;
		animation-fill-mode: forwards;
	}
	.lbtext4 .name2{
		margin:80px 0 0 0;
		width: 92px;
		height: 298px;
		text-align: center;
		color: #fff;
		opacity: 0;
		animation: lb1img 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	
	
</style>